import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import useFieldProps from 'pages/company/DashboardRoute/pages/VendorExpensesRoute/components/Filters/useFieldProps';

type FieldProps = ReturnType<typeof useFieldProps>;
type FilterModel = ReturnType<FieldProps['getCurrentValues']>;

type VendorExpensesContextValue = {
  fieldProps: FieldProps;
  filterModel: FilterModel;
  detailsIsExpanded: boolean;
  handleChangeDetailsIsExpanded: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const VendorExpensesContext = createContext<VendorExpensesContextValue | null>(null);

export const useVendorExpensesContext = () => {
  const context = useContext(VendorExpensesContext);
  if (!context) {
    throw new Error('useVendorExpensesContext must be used within VendorExpensesProvider');
  }
  return context;
};

export const VendorExpensesProvider = ({ children }: { children: React.ReactNode }) => {
  const fieldProps = useFieldProps();
  const [detailsIsExpanded, setDetailsIsExpanded] = useState(false);

  const filterModel = fieldProps.getCurrentValues();

  const handleChangeDetailsIsExpanded = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    setDetailsIsExpanded(event.target.checked);
  }, []);

  const contextValue = useMemo(
    () => ({
      fieldProps,
      filterModel,
      detailsIsExpanded,
      handleChangeDetailsIsExpanded,
    }),
    [fieldProps, filterModel, detailsIsExpanded, handleChangeDetailsIsExpanded],
  );

  return <VendorExpensesContext.Provider value={contextValue}>{children}</VendorExpensesContext.Provider>;
};
